import { render, staticRenderFns } from "./QuestionType9.vue?vue&type=template&id=65afd3be&scoped=true"
import script from "./QuestionType9.vue?vue&type=script&lang=js"
export * from "./QuestionType9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65afd3be",
  null
  
)

export default component.exports